import { CartEvent, CartModification, OrderEntry } from "@spartacus/cart/base/root";

export class UdxCartAddEntryEvent extends CartEvent {
    /**
     * Event's type
     */
    static override readonly type = 'UdxCartAddEntryEvent';
    productCode: string | undefined;
    quantity: number | undefined;
  }
  export class UdxCartAddEntrySuccessEvent extends CartEvent {
    /**
     * Event's type
     */
    static override readonly type = "UdxCartAddEntrySuccessEvent";
    productCode?: string;
    quantity?: number;
    entry?: OrderEntry;
    quantityAdded?: number;
    deliveryModeChanged?: boolean;
    cartModifications?: CartModification
}
  